import React from 'react';
import {Link, useNavigate, useLocation} from 'react-router-dom';
import {useDispatch} from "react-redux";

import '../../../assets/style/css/styleErrorPage.css';
import {authenticationActions} from "../../../actions/index";

export const ErrorPage = () => {

    const {state} = useLocation();
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const initAuth = React.useCallback(() => dispatch(authenticationActions.initAuth()), [dispatch]);

    const getMessage = () => {
        let message = 'Errore durante il recupero dei dati';

        if (state != null) {
            if (state.status != null) {
                if (state.message != null) {
                    message = state.status + ' - ' + state.message;
                } else {
                    message = state.status
                }
            } else if (state.message != null) {
                message = state.message;
            }
        }
        return message;
    }

    return (
        <div className='animate__animated animate__fadeIn'>
            <div id='notfound' style={{position: 'static'}}>
                <div className='notfound'>
                    <div className='notfound-404'>
                        <h1>Oops!</h1>
                        <div id='subtitle'>{getMessage()}</div>
                    </div>
                    <Link to='/login' onClick={() => {
                        initAuth();
                        sessionStorage.clear();
                        navigate('/login')
                    }}>
                        <div id='similLink' className='shadow'>Go TO Homepage</div>
                    </Link>
                </div>
            </div>
        </div>
    );
}

